
 import { authenticatedFetch } from "../Auth/Auth";
 import { getCurrentConfig } from '../../config/config';
 
 const config = getCurrentConfig();

export const editListing = async (editListingJSONbody) => {
   
 
    const response = await authenticatedFetch(`${config.API_BASE_URL}/listings`, {
        method: 'PUT',
        headers: {
        
          'Content-Type': 'application/json',
          'User-Agent': 'agentApp/1.0',
        },
        body: JSON.stringify(editListingJSONbody)
      });
      
      if (response.ok) {
        const responseData = await response.json();
        return responseData;
      } else {
        throw new Error(`Error edit listing`);
      }




};